<template>
  <div class="info_box">
    <el-form :inline="true" :model="customerInfo" class="demo-form-inline" label-width="120px" size="mini">
      <el-form-item label="公司名称">
        <el-input v-model="customerInfo.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="公司地址">
        <el-input v-model="customerInfo.address" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="customerInfo.linkman" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="所属人">
        <el-input v-model="customerInfo.salesman_name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="customerInfo.phone" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="电话/传真">
        <el-input v-model="customerInfo.fax" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="微信">
        <el-input v-model="customerInfo.wechat" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱">
        <el-input v-model="customerInfo.email" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="所在省份">
        <el-input v-model="customerInfo.province_name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="所在城市">
        <el-input v-model="customerInfo.city_name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="客户属性">
        <el-input v-model="customerInfo.customer_attribute_name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="客户来源">
        <el-input v-model="customerInfo.customer_source_name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="主营项目">
        <el-input v-model="customerInfo.main_business" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="信用指数">
        <el-input v-model="customerInfo.star" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="customerInfo.remark" placeholder=""></el-input>
      </el-form-item>
      <el-row class="type_title">开票类型</el-row>
      <el-row class="type_box">
          <el-form-item label="名称">
              <el-input v-model="invoiceInfo.invoice_name" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="开户行">
              <el-input v-model="invoiceInfo.invoice_bank_name" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="税号">
              <el-input v-model="invoiceInfo.invoice_no" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="帐号">
              <el-input v-model="invoiceInfo.invoice_bank_no" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="地址">
              <el-input v-model="invoiceInfo.invoice_addr" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="电话">
              <el-input v-model="invoiceInfo.invoice_phone" placeholder=""></el-input>
          </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    customerInfo: {
      type: Object,
      default(){
        return {
          name: ''
        }
      }
    },
    invoiceInfo:{
      type: Object,
      default(){
        return {}
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.info_box{
    width: 800px;
    height: 100%;
    padding: 10px 20px;
    overflow: auto;
    text-align: left;
    .type_title{
        width: 700px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 10px;
    }
    .type_box{
        width: 700px;
        padding: 20px 0;
        background-color: #e4e4e4;
    }
}
</style>